import { render, staticRenderFns } from "./icon-plus.vue?vue&type=template&id=11e2437c&"
import script from "./icon-plus.vue?vue&type=script&lang=js&"
export * from "./icon-plus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports